import { type FC } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { useCurrentPlatformQuery } from "@/partner/entities/platforms";
import { VideosFilter } from "./VideosFilter";
import { VideosList } from "./VideosList";
import { CreateVideoDialog } from "./CreateVideoDialog";
import { EditVideoDialog } from "./EditVideoDialog";
import { UploadsZone } from "./UploadsZone";
import { UploadsDialog } from "./UploadsDialog";
import { useMultipleUploads } from "./useMultipleUploads";

export const Videos: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { items, startUploads, clear, cancelItem, confirmCreate, creating } =
    useMultipleUploads();

  const { data: platformData } = useCurrentPlatformQuery();
  const streamingAvailable = Boolean(
    platformData?.currentPlatform?.streamingAvailable
  );

  const tab = searchParams.get("tab");
  const editId = searchParams.get("id");

  const handleEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCreate = () => {
    searchParams.set("tab", "create");
    setSearchParams(searchParams);
  };

  const handleClose = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <UploadsZone onFiles={startUploads}>
        <Stack spacing={1}>
          <VideosFilter
            onCreateContent={handleCreate}
            streamingAvailable={streamingAvailable}
          />
          <VideosList onEditContent={handleEdit} />
        </Stack>
      </UploadsZone>

      <CreateVideoDialog
        open={tab === "create"}
        onClose={handleClose}
        onSelectFiles={startUploads}
      />
      <EditVideoDialog
        // ?tab= несёт активную вкладку формы (референсный VideoForm/Menu):
        // edit — редактирование, timecodes — метки таймлайна.
        // Записи 2257 живут во вкладке records2257 (спека §4).
        open={
          (tab === "edit" || tab === "timecodes" || tab === "records2257") &&
          Boolean(editId)
        }
        contentId={editId}
        tab={tab ?? "edit"}
        onClose={handleClose}
        onCompleted={handleClose}
      />
      <UploadsDialog
        items={items}
        onClose={clear}
        onCancelItem={cancelItem}
        onConfirm={confirmCreate}
        creating={creating}
      />
    </FilterProvider>
  );
};
